export default __webpack_public_path__ + "static/header-title-do-light-6178be8dcf1a433e55caa9caae687b4b.png";